export type MessageStatus =
  | "warning"
  | "info"
  | "success"
  | "error"
  | undefined;

export type MessageVariant = "solid" | "subtle" | undefined;

export interface ILink {
  description: string;
  text: string;
  href: string;
}

export interface IMessage {
  status: MessageStatus;
  variant: MessageVariant;
  content: string;
  link: ILink | null;
  colorScheme?: string;
  color?: string;
}

export const messages: Array<IMessage> = require("./config/messages.json");
